export default "__VITE_ASSET__DZztY0AI__"